import React, {useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import CollateFrame from '../components/frame/CollateFrame';
import frameCss from '../components/frame/CollateFrame.module.css';
import AdminHome from './Home';
import AdminOps from './Ops';
import AdminOpsSingle from './OpsSingle';
import AdminTaskSingle from './TaskSingle';
import ReleasesList from './ReleasesList';
import ReleaseDetail from './ReleaseDetail';
import BranchesList from './BranchesList';
import BranchDetail from './BranchDetail';
import CciJobsList from './CciJobsList';
import CciJobDetail from './CciJobDetail';
import { createSocket, WebSocketContext } from '../api/socket';
import { Route, Routes } from 'react-router-dom';

export const Frame = (props) => {
  const { user } = props
  const navigate = useNavigate();
  const [ws, setWS] = React.useState(null);
    
  useEffect(() => {
    if (user.status === 'unauthed') {
        navigate('/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (ws === null) {
      const socket = createSocket();

      socket.on("reconnect", (attempt) => {
          console.log("[WS] Reconnected after ", attempt, " attempts");
        });
      socket.on("error", (error) => {
        console.log("[WS] Error connecting to WS: ", error);
      });

      setWS(socket);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setWS]);
  

  const Pad = ({ children }) => <div className={frameCss.pagePad}>{children}</div>;

  return (
    <WebSocketContext.Provider value={ws}>
    <CollateFrame user={user}>
        <Routes>
            <Route path="ops" element={<Pad><AdminOps user={user} /></Pad>} />
            <Route path="ops/:op_id" element={<Pad><AdminOpsSingle user={user} /></Pad>} />
            <Route path="task/:task_id" element={<Pad><AdminTaskSingle user={user} /></Pad>} />
            <Route path="/releases" element={<ReleasesList user={user} />} />
            <Route path="/releases/:version" element={<ReleaseDetail user={user} />} />
            <Route path="/branches" element={<BranchesList user={user} />} />
            <Route path="/branches/:version" element={<BranchDetail user={user} />} />
            {/* CI jobs: private for now, so deliberately not in the side panel */}
            <Route path="/cci" element={<CciJobsList user={user} />} />
            <Route path="/cci/:job_id" element={<CciJobDetail user={user} />} />
            <Route path="/" element={<AdminHome user={user} />} />
        </Routes>
    </CollateFrame>
    </WebSocketContext.Provider>
  )
}

export default Frame;